import React, { useEffect, useState } from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import styles from './Payments.module.css';
import { createStripeConnectDashboardLink } from '../../services/stripe';

const PaymentsHeader = ({ isStripeConnected, walkthrough }) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    if (!isVideoOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsVideoOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isVideoOpen]);

  const hasWalkthrough = Boolean(walkthrough?.embedUrl);

  const handleViewDashboard = async () => {
    try {
      const dashboardUrl = await createStripeConnectDashboardLink(window.location.href);
      window.location.href = dashboardUrl;
    } catch (error) {
      console.error('Failed to create dashboard link:', error);
      alert('Unable to open Stripe dashboard. Please try again.');
    }
  };

  return (
    <div className={styles.headerCard}>
      <div className={styles.headerContent}>
        <h1 className={styles.headerTitle}>Payments</h1>
        <p className={styles.headerDescription}>
          Manage your payment setup, invoices, and payouts
        </p>
        {hasWalkthrough && (
          <div className={styles.walkthroughRow}>
            <button
              type="button"
              className={styles.walkthroughButton}
              onClick={() => setIsVideoOpen(true)}
            >
              <svg
                className={styles.walkthroughIcon}
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M8 5.14v13.72a1 1 0 0 0 1.55.83l9.2-6.86a1 1 0 0 0 0-1.66l-9.2-6.86A1 1 0 0 0 8 5.14z" />
              </svg>
              Watch walkthrough
            </button>
            {walkthrough?.durationLabel && (
              <span className={styles.walkthroughDuration}>
                {walkthrough.durationLabel}
              </span>
            )}
        </div>
      )}
      </div>

      {isVideoOpen && (
        <div
          className={styles.videoModalOverlay}
          onClick={() => setIsVideoOpen(false)}
        >
          <div
            className={styles.videoModal}
            onClick={(event) => event.stopPropagation()}
          >
            <div className={styles.videoModalHeader}>
              <div className={styles.videoModalTitle}>
                {walkthrough?.title || 'Payments walkthrough'}
              </div>
              <button
                type="button"
                className={styles.videoModalClose}
                onClick={() => setIsVideoOpen(false)}
                aria-label="Close video"
              >
                ✕
              </button>
            </div>

            <div className={styles.videoFrame}>
              <iframe
                src={walkthrough.embedUrl}
                title={walkthrough?.title || 'Payments walkthrough'}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}

      {isStripeConnected && (
        <button
          onClick={handleViewDashboard}
          className={styles.dashboardButton}
          type="button"
        >
          View Stripe Dashboard
          <ArrowTopRightOnSquareIcon className={styles.dashboardIcon} />
        </button>
      )}
    </div>
  );
};

export default PaymentsHeader;